import { Link } from "react-router-dom";
import { Target, Eye, Heart, ArrowUpRight, Award, Globe } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";

const VALUES = [
  { icon: Heart, t: "Patient First", d: "Every product decision starts with: does this make the patient's life better?" },
  { icon: Award, t: "Clinical Rigor", d: "We co-build with doctors and nurses. No feature ships without their sign-off." },
  { icon: Globe, t: "Bias for Scale", d: "Designed from day zero to handle a single clinic — and a 500-hospital network." },
];

const STATS = [
  ["500+", "Healthcare Facilities"],
  ["12M+", "Patient Records"],
  ["48hr*", "Average Go-Live"],
  ["12+", "Languages Supported"],
];

export default function About() {
  return (
    <div data-testid="page-about">
      <section className="relative bg-[color:var(--paper-2)] overflow-hidden">
        <div className="absolute inset-0 bg-grid-light opacity-40" />
        <div className="relative container-x pt-4 md:pt-6 lg:pt-8 pb-0">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <div className="eyebrow">About SAALUVARS</div>
              <h1 className="h-hero text-4xl sm:text-6xl mt-4">
                We&apos;re building the <span className="text-[color:var(--brand)]">operating system</span> for modern healthcare.
              </h1>
              <p className="mt-5 text-lg text-slate-600 max-w-xl">
                SAALUVARS exists because healthcare is too important to be stuck on paper, fax machines and disconnected legacy systems. We&apos;re a team of doctors, engineers and operators on a mission to connect every part of the patient journey.
              </p>
              <div className="mt-7 flex gap-3">
              {/*
                <Link to="/contact" className="btn-primary">Partner With Us <ArrowUpRight className="w-4 h-4" /></Link>
                <Link to="/request-demo" className="btn-ghost">Book a Demo</Link>
              */}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {STATS.map(([n, l]) => (
                <div key={l} className="rounded-2xl bg-white border border-slate-200 p-6">
                  <div className="text-4xl md:text-5xl font-bold text-slate-900" style={{ fontFamily: "'Outfit',sans-serif" }}>{n}</div>
                  <div className="mt-1 text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section-y !pt-4 md:!pt-8 bg-white">
        <div className="container-x grid md:grid-cols-2 gap-10">
          <div className="rounded-2xl border border-slate-200 p-8">
            <Target className="w-7 h-7 text-[color:var(--brand)]" />
            <h3 className="mt-4 text-2xl font-bold">Our Mission</h3>
            <p className="mt-3 text-slate-600">
              Connect every healthcare entity in a single AI-powered ecosystem — so doctors can spend more time with patients and patients can own their health journey forever.
            </p>
          </div>
          <div className="rounded-2xl border border-slate-200 p-8">
            <Eye className="w-7 h-7 text-[color:var(--brand)]" />
            <h3 className="mt-4 text-2xl font-bold">Our Vision</h3>
            <p className="mt-3 text-slate-600">
              A world where your health record follows you across cities, countries and decades — and where AI quietly removes every friction between symptom and care.
            </p>
          </div>
        </div>

        <div className="container-x mt-20">
          <SectionHeader eyebrow="What we believe" title="Three values" titleAccent="we don't compromise on." />
          <div className="mt-10 grid md:grid-cols-3 gap-5">
            {VALUES.map((v, i) => (
              <div key={v.t} className="rounded-2xl bg-[color:var(--paper-2)] p-7" data-testid={`value-${i + 1}`}>
                <div className="w-11 h-11 rounded-xl bg-white border border-slate-200 grid place-items-center text-[color:var(--brand)]">
                  <v.icon className="w-5 h-5" />
                </div>
                <h3 className="mt-5 text-xl font-bold">{v.t}</h3>
                <p className="mt-2 text-sm text-slate-600">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
